// import React, { useEffect, useState } from "react";
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions, Button,
//   TextField, Select, MenuItem, InputLabel, FormControl,
//   Box, Typography, Alert, Chip, Divider,
// } from "@mui/material";

// import { getVendors, assignVendor } from "../services/api";
// import { formatDate } from "../utils/DateFormatter";

// const AssignVendorDialog = ({ open, onClose, booking, onAssigned }) => {
//   const [vendors, setVendors] = useState([]);
//   const [loadingVendors, setLoadingVendors] = useState(false);
//   const [vendorId, setVendorId] = useState("");
//   const [pickupTime, setPickupTime] = useState("");
//   const [notes, setNotes] = useState("");
//   const [submitting, setSubmitting] = useState(false);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     if (open && booking) {
//       // Reset state
//       setVendorId("");
//       setPickupTime("");
//       setNotes("");
//       setError("");

//       // Fetch vendors for booking's category
//       setLoadingVendors(true);
//       getVendors(booking.category || "RIDE")
//         .then((res) => {
//           setVendors(res.data.data || []);
//         })
//         .catch((err) => {
//           setError("Failed to load vendors");
//         })
//         .finally(() => setLoadingVendors(false));
//     }
//   }, [open, booking]);

//   const handleSubmit = async () => {
//     if (!vendorId) {
//       setError("Please select a vendor");
//       return;
//     }

//     setSubmitting(true);
//     setError("");

//     try {
//       await assignVendor(booking.bookingId, {
//         vendorId: Number(vendorId),
//         pickupTime: pickupTime || null,
//         notes: notes.trim() || null,
//       });
//       onAssigned("Vendor assigned successfully");
//     } catch (err) {
//       setError(err.response?.data?.message || "Assignment failed");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   if (!booking) return null;

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle>
//         Assign Vendor — Booking #{booking.bookingId}
//       </DialogTitle>
//       <DialogContent>
//         <Box display="flex" flexDirection="column" gap={2} mt={1}>
//           {/* Booking summary */}
//           <Box p={2} bgcolor="grey.100" borderRadius={1}>
//             <Typography variant="body2" mb={1}>
//               <strong>{booking.name}</strong>{" "}
//               <Chip label={booking.category || "RIDE"} size="small" sx={{ ml: 1 }} />
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               📞 {booking.contactNumber}
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               📅 {formatDate(booking.fromDate)}
//             </Typography>
//             <Typography variant="body2" color="text.secondary" mt={1}>
//               <strong>From:</strong> {booking.homeAddress}
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               <strong>To:</strong> {booking.officeAddress}
//             </Typography>
//             <Typography variant="body2" color="text.secondary" mt={1}>
//               <strong>Passengers:</strong> {booking.passengerCount} | <strong>Distance:</strong> {booking.distance} km | <strong>Fare:</strong> ₹{booking.fare}
//             </Typography>
//           </Box>

//           <Divider />

//           {error && (
//             <Alert severity="error" onClose={() => setError("")}>
//               {error}
//             </Alert>
//           )}

//           <FormControl fullWidth required>
//             <InputLabel>Select Vendor</InputLabel>
//             <Select
//               value={vendorId}
//               label="Select Vendor"
//               onChange={(e) => {
//                 setVendorId(e.target.value);
//                 setError("");
//               }}
//               disabled={loadingVendors}
//             >
//               {loadingVendors ? (
//                 <MenuItem disabled>Loading vendors...</MenuItem>
//               ) : vendors.length === 0 ? (
//                 <MenuItem disabled>
//                   No active vendors for {booking.category || "RIDE"} category
//                 </MenuItem>
//               ) : (
//                 vendors.map((v) => (
//                   <MenuItem key={v.vendorId} value={v.vendorId}>
//                     <Box>
//                       <Typography variant="body2">
//                         <strong>{v.vendorName}</strong>{" "}
//                         <Chip label={v.vendorType} size="small" sx={{ ml: 1 }} />
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         {v.contactPerson} • {v.contactNumber}
//                         {v.vehicleNumber && ` • ${v.vehicleNumber}`}
//                       </Typography>
//                     </Box>
//                   </MenuItem>
//                 ))
//               )}
//             </Select>
//           </FormControl>

//           <TextField
//             label="Pickup Time"
//             type="time"
//             value={pickupTime}
//             onChange={(e) => setPickupTime(e.target.value)}
//             fullWidth
//             InputLabelProps={{ shrink: true }}
//             helperText="When should the vendor pick up the customer?"
//           />

//           <TextField
//             label="Notes (optional)"
//             value={notes}
//             onChange={(e) => setNotes(e.target.value)}
//             fullWidth
//             multiline
//             rows={2}
//             placeholder="e.g., Customer has 2 bags, prefers AC vehicle, etc."
//           />

//           {vendors.length === 0 && !loadingVendors && (
//             <Alert severity="info">
//               No active vendors found for this category. Please add vendors first via Vendor Management.
//             </Alert>
//           )}
//         </Box>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} disabled={submitting}>
//           Cancel
//         </Button>
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           disabled={submitting || !vendorId || vendors.length === 0}
//         >
//           {submitting ? "Assigning..." : "Assign Vendor"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AssignVendorDialog;
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Typography,
  Alert,
  Chip,
  Divider,
  Stack,
  IconButton,
  Avatar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import EventIcon from "@mui/icons-material/Event";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import GroupIcon from "@mui/icons-material/Group";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";

import { getVendors, assignVendor } from "../services/api";
import { formatDate } from "../utils/DateFormatter";

const AssignVendorDialog = ({ open, onClose, booking, onAssigned }) => {
  const [vendors, setVendors] = useState([]);
  const [loadingVendors, setLoadingVendors] = useState(false);
  const [vendorId, setVendorId] = useState("");
  const [pickupTime, setPickupTime] = useState("");
  const [notes, setNotes] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open && booking) {
      setVendorId("");
      setPickupTime("");
      setNotes("");
      setError("");

      setLoadingVendors(true);
      getVendors(booking.category || "RIDE")
        .then((res) => {
          setVendors(res.data.data || []);
        })
        .catch((err) => {
          setError("Failed to load vendors");
        })
        .finally(() => setLoadingVendors(false));
    }
  }, [open, booking]);

  const handleSubmit = async () => {
    if (!vendorId) {
      setError("Please select a vendor");
      return;
    }

    setSubmitting(true);
    setError("");

    try {
      await assignVendor(booking.bookingId, {
        vendorId: Number(vendorId),
        pickupTime: pickupTime || null,
        notes: notes.trim() || null,
      });
      onAssigned("Vendor assigned successfully");
    } catch (err) {
      setError(err.response?.data?.message || "Assignment failed");
    } finally {
      setSubmitting(false);
    }
  };

  if (!booking) return null;

  const selectedVendor = vendors.find((v) => v.vendorId === Number(vendorId));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      {/* Header */}
      <DialogTitle sx={{ pb: 1, pr: 6 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 2,
              bgcolor: "primary.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
            }}
          >
            <LocalTaxiIcon />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight="bold">
              Assign Driver
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Booking #{booking.bookingId}
            </Typography>
          </Box>
        </Box>
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 12, top: 12 }}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 3 }}>
        <Stack spacing={3}>
          {/* Booking summary */}
          <Box>
            <Typography
              variant="caption"
              color="text.secondary"
              fontWeight={600}
              sx={{ textTransform: "uppercase", letterSpacing: 0.5 }}
            >
              Booking Details
            </Typography>
            <Box
              sx={{
                mt: 1,
                p: 2,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
                bgcolor: "#fafbfc",
              }}
            >
              {/* Customer */}
              <Box display="flex" alignItems="center" gap={1.5} mb={2}>
                <Avatar
                  sx={{
                    bgcolor: "primary.main",
                    width: 36,
                    height: 36,
                    fontSize: "0.9rem",
                    fontWeight: 700,
                  }}
                >
                  {booking.name?.charAt(0)?.toUpperCase() || "?"}
                </Avatar>
                <Box flex={1}>
                  <Typography variant="body2" fontWeight={600}>
                    {booking.name}
                  </Typography>
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <PhoneIcon sx={{ fontSize: 12, color: "text.secondary" }} />
                    <Typography variant="caption" color="text.secondary">
                      {booking.contactNumber}
                    </Typography>
                  </Box>
                </Box>
                <Chip
                  label={booking.category || "RIDE"}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
              </Box>

              <Divider sx={{ my: 1.5 }} />

              {/* Date */}
              <Box display="flex" alignItems="center" gap={1} mb={1.5}>
                <EventIcon sx={{ fontSize: 16, color: "text.secondary" }} />
                <Typography variant="body2">
                  {formatDate(booking.fromDate)}
                </Typography>
              </Box>

              {/* Pickup */}
              <Box display="flex" alignItems="flex-start" gap={1} mb={1}>
                <LocationOnIcon sx={{ fontSize: 16, color: "success.main", mt: 0.2 }} />
                <Box>
                  <Typography variant="caption" color="success.dark" fontWeight={700}>
                    PICKUP
                  </Typography>
                  <Typography variant="body2">{booking.homeAddress}</Typography>
                </Box>
              </Box>

              {/* Drop */}
              <Box display="flex" alignItems="flex-start" gap={1} mb={1.5}>
                <BusinessIcon sx={{ fontSize: 16, color: "error.main", mt: 0.2 }} />
                <Box>
                  <Typography variant="caption" color="error.dark" fontWeight={700}>
                    DROP
                  </Typography>
                  <Typography variant="body2">{booking.officeAddress}</Typography>
                </Box>
              </Box>

              <Divider sx={{ my: 1.5 }} />

              {/* Trip stats */}
              <Stack direction="row" spacing={2} flexWrap="wrap">
                <Box display="flex" alignItems="center" gap={0.5}>
                  <GroupIcon sx={{ fontSize: 14, color: "text.secondary" }} />
                  <Typography variant="caption">
                    {booking.passengerCount} {booking.passengerCount === 1 ? "passenger" : "passengers"}
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <DirectionsCarIcon sx={{ fontSize: 14, color: "text.secondary" }} />
                  <Typography variant="caption">{booking.distance} km</Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <Typography variant="caption" fontWeight={600} color="success.dark">
                    ₹{booking.fare}
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Box>

          {/* Error alert */}
          {error && (
            <Alert severity="error" onClose={() => setError("")}>
              {error}
            </Alert>
          )}

          {/* Vendor selection */}
          <Box>
            <Typography
              variant="caption"
              color="text.secondary"
              fontWeight={600}
              sx={{ textTransform: "uppercase", letterSpacing: 0.5, mb: 1, display: "block" }}
            >
              Select Driver / Vendor
            </Typography>
            <FormControl fullWidth required>
              <InputLabel>Choose a vendor</InputLabel>
              <Select
                value={vendorId}
                label="Choose a vendor"
                onChange={(e) => {
                  setVendorId(e.target.value);
                  setError("");
                }}
                disabled={loadingVendors}
                renderValue={(selected) => {
                  // Custom render for selected value (single line, no overlap)
                  const v = vendors.find((v) => v.vendorId === selected);
                  if (!v) return "";
                  return (
                    <Box display="flex" alignItems="center" gap={1}>
                      <PersonIcon sx={{ fontSize: 18, color: "primary.main" }} />
                      <Typography variant="body2" fontWeight={600}>
                        {v.vendorName}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        • {v.contactNumber}
                      </Typography>
                    </Box>
                  );
                }}
              >
                {loadingVendors ? (
                  <MenuItem disabled>Loading vendors...</MenuItem>
                ) : vendors.length === 0 ? (
                  <MenuItem disabled>
                    No active vendors for {booking.category || "RIDE"} category
                  </MenuItem>
                ) : (
                  vendors.map((v) => (
                    <MenuItem key={v.vendorId} value={v.vendorId} sx={{ py: 1.5 }}>
                      <Box width="100%">
                        {/* Top row: name + type chip */}
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                          <Typography variant="body2" fontWeight={600}>
                            {v.vendorName}
                          </Typography>
                          <Chip
                            label={v.vendorType}
                            size="small"
                            variant="outlined"
                            sx={{ height: 20, fontSize: "0.65rem" }}
                          />
                        </Box>

                        {/* Bottom row: contact info */}
                        <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
                          <Box display="flex" alignItems="center" gap={0.3}>
                            <PersonIcon sx={{ fontSize: 12, color: "text.secondary" }} />
                            <Typography variant="caption" color="text.secondary">
                              {v.contactPerson}
                            </Typography>
                          </Box>
                          <Box display="flex" alignItems="center" gap={0.3}>
                            <PhoneIcon sx={{ fontSize: 12, color: "text.secondary" }} />
                            <Typography variant="caption" color="text.secondary">
                              {v.contactNumber}
                            </Typography>
                          </Box>
                          {v.vehicleNumber && (
                            <Box display="flex" alignItems="center" gap={0.3}>
                              <DirectionsCarIcon sx={{ fontSize: 12, color: "text.secondary" }} />
                              <Typography variant="caption" color="text.secondary">
                                {v.vehicleNumber}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Box>

          {/* Pickup time */}
          <Box>
            <Typography
              variant="caption"
              color="text.secondary"
              fontWeight={600}
              sx={{ textTransform: "uppercase", letterSpacing: 0.5, mb: 1, display: "block" }}
            >
              Pickup Time
            </Typography>
            <TextField
              type="time"
              value={pickupTime}
              onChange={(e) => setPickupTime(e.target.value)}
              fullWidth
              InputLabelProps={{ shrink: true }}
              InputProps={{
                startAdornment: (
                  <AccessTimeIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />
                ),
              }}
              helperText="When should the driver pick up the customer?"
            />
          </Box>

          {/* Notes */}
          <Box>
            <Typography
              variant="caption"
              color="text.secondary"
              fontWeight={600}
              sx={{ textTransform: "uppercase", letterSpacing: 0.5, mb: 1, display: "block" }}
            >
              Special Instructions (Optional)
            </Typography>
            <TextField
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              fullWidth
              multiline
              rows={3}
              placeholder="e.g., Customer has 2 bags, prefers AC vehicle, building has gate code 1234..."
              InputProps={{
                startAdornment: (
                  <NoteAltIcon
                    sx={{
                      fontSize: 20,
                      color: "text.secondary",
                      mr: 1,
                      mt: 1.5,
                      alignSelf: "flex-start",
                    }}
                  />
                ),
              }}
            />
          </Box>

          {/* No vendors info */}
          {vendors.length === 0 && !loadingVendors && (
            <Alert severity="info" variant="outlined">
              No active vendors found for this category. Please add vendors first via Vendor Management.
            </Alert>
          )}
        </Stack>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={submitting || !vendorId || vendors.length === 0}
          startIcon={submitting ? null : <LocalTaxiIcon />}
          sx={{ px: 3 }}
        >
          {submitting ? "Assigning..." : "Confirm Assignment"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignVendorDialog;